
import BreadcrumbOne from "components/common/breadcrumb/breadcrumb-one";
import FilterGallaryThree from "components/common/filter-gallary/filter-gallary-three";
// const FilterGallaryThree = dynamic(() => import(""), {
// 	ssr: false,
// });

export default function PortfolioTwo() {
	return (
		<>
			<BreadcrumbOne title="Portfolio 02" />
			<FilterGallaryThree />
		</>
	);
}
